import { WalletActionCreators } from 'actions/wallet';
import { WalletAccountState } from 'models/wallet';

export const initialState: WalletAccountState = {
  isLoading: false,
  walletAccount: {
    balance: 0,
    moneyInPerMonth: 0,
    type: {
      allowPayment: false,
      allowRedeem: false,
      allowTransfer: false,
      balanceLimit: 0,
      id: '',
      moneyInLimitPerMonth: 0,
      name: ''
    }
  }
};

type Action = typeof WalletActionCreators[keyof typeof WalletActionCreators];

export function walletAccountReducer(state = initialState, action: Action): typeof initialState {
  switch (action.type) {
    case WalletActionCreators.setAccountIsOnRequest.type:
      return { ...state, isLoading: true };
    case WalletActionCreators.setAccountIsReceived.type:
      return { ...state, isLoading: false };
    case WalletActionCreators.updateMoneyInPerMonth.type: {
      const walletAccount = { ...state.walletAccount, moneyInPerMonth: action.payload };
      return { ...state, walletAccount };
    }
    case WalletActionCreators.updateAccount.type: {
      const walletAccount = { ...action.payload };
      return { ...state, walletAccount };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/wallet/account.ts